<div class="ehr__header">
  <admin-breadcrumbs></admin-breadcrumbs>
  <h3>EHR Sources — Region Assignment</h3>
</div>

<div class="ehr__body">

  <div *ngIf="loading">Loading...</div>

  <div *ngIf="!loading" class="ehr__table-container">
    <table class="ehr__table">
      <tr class="ehr__row">
        <th class="ehr__th">
          <input type="checkbox" [checked]="allSelected"
            (change)="onSelectAll($any($event.target).checked)" />
          Select All
        </th>
        <th class="ehr__th">Source Name</th>
      </tr>
      <tr *ngFor="let source of ehrSources" class="ehr__row">
        <td class="ehr__td">
          <input type="checkbox" [checked]="source.assignedToRegion"
            (change)="onEhrSourceToggle(source, $any($event.target).checked)" />
        </td>
        <td class="ehr__td">{{ source.name }}</td>
      </tr>
      <tr *ngIf="!ehrSources.length" class="ehr__row">
        <td class="ehr__td" colspan="2">No EHR sources found.</td>
      </tr>
    </table>
  </div>

</div>
